import Notification from 'interfaces/Notification';
import '../stylesheets/NotificationDetails.scss';

type CertificationOrTrainingOverdueProps = {
    notification: Notification;
};

const CertificationOrTrainingOverdue = ({
    notification,
}: CertificationOrTrainingOverdueProps) => {
    const trainingYear = notification.actionMetadata?.['TrainingYear'];
    const certificationPortalUrl =
        notification?.actionMetadata?.['CertificationPortalUrl'];

    return (
        <div id="notification-details-content">
            <p>
                Your required {trainingYear} certifications or training are
                overdue. Please complete the necessary certifications and
                training as soon as possible to maintain ready to sell status.
            </p>
            <a
                className="font-weight-bold"
                href={certificationPortalUrl}
                target="_blank"
                rel="noopener noreferrer"
            >
                Click Here to launch Certification Portal.
            </a>
        </div>
    );
};
export default CertificationOrTrainingOverdue;
